export default "__VITE_ASSET__CsC3kiTg__"